export type StopTypeIconKind =
	| "TOPIC"
	| "BATTLE"
	| "SCENARIO"
	| "ACTION"
	| "BOSS"
	| "MODULE"
	| "COURSE"
	| "gate"
	| "key";

export const STOP_TYPE_ICON_SRC: Record<StopTypeIconKind, string> = {
	TOPIC: "/images/stops/stop-topic.png",
	BATTLE: "/images/stops/stop-battle.png",
	SCENARIO: "/images/stops/stop-chat.png",
	ACTION: "/images/stops/stop-assignment.png",
	BOSS: "/images/stops/stop-boss-battle.png",
	MODULE: "/images/module.png",
	COURSE: "/images/certificate.png",
	gate: "/images/stops/stop-gate.png",
	key: "/images/stops/stop-key.png",
};

export function resolveStopTypeIconSrc(
	kind: StopTypeIconKind | string | null | undefined,
): string | null {
	if (typeof kind !== "string" || kind.trim().length === 0) {
		return null;
	}
	const src = STOP_TYPE_ICON_SRC[kind as StopTypeIconKind];
	return typeof src === "string" && src.trim().length > 0 ? src : null;
}
